import React from 'react';

import SearchForm from '../../../../../SearchForm';

import SearchService from '../../../../../../../services/SearchService';
import useUserRole from '../../../../../../../hooks/useUserRole';
import extractLoansFromSearchResults from './helpers/extractLoansFromSearchResults';
import formatResults from '../../../../../../ModalSearch/SearchResults/ResultsGroup/SearchResult/helpers/formatResults';
import createResultString from '../../../../../../ModalSearch/SearchResults/ResultsGroup/SearchResult/helpers/createResultString';

export default function Search({ loanGroup, updateLoanGroup }) {
  const { isLender } = useUserRole();

  return (
    <div className="mb-6 flex max-w-[500px] w-full border-1">
      <SearchForm
        style={{ width: '100%' }}
        queryKey={['loanSearch']}
        queryFn={async (args) => {
          try {
            const results = await SearchService.search(args);

            return extractLoansFromSearchResults(results);
          } catch (error) {
            console.log('Error fetching loans:', error);
            return [];
          }
        }}
        queryFnParams={{ isLender }}
        placeholder="Search loans"
        noResultsText="No loans found"
        formatSearchResult={(result) => {
          return createResultString(
            result,
            formatResults(result, 'loans', isLender)
          );
        }}
        onResultSelect={(result) => {
          const loanId = result.id;

          const prevIds = loanGroup?.loan_id
            ?.filter(Boolean)
            ?.map((loan) => loan._loan.id);

          if (!prevIds.includes(loanId)) {
            updateLoanGroup({
              ...loanGroup,
              loan_id: [...prevIds, loanId],
            });
          }
        }}
      />
    </div>
  );
}
